var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 6.082v11.84c0 .96-1.214 1.44-1.926.76l-5.422-5.18a2.064 2.064 0 0 1 0-3.01l2.062-1.97 3.36-3.21c.712-.67 1.926-.19 1.926.77Z","fill":"var(--v-blue-lighten-1)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }